import BaseService from '../BaseService';
import api from '../../services/api';

const RECURSO_DOCUMENTOS = '/atendimentos/historico-clinico/documentos/';

class HistoricoClinicoService extends BaseService {
    constructor() {
        super('/atendimentos/historico-clinico/');
    }

    listar(atendimentoId) {
        return this.getAll({ atendimento_id: atendimentoId });
    }

    enviarDocumento(historicoId, tipo, descricao, arquivo) {
        const formData = new FormData();
        formData.append('historico_clinico_id', historicoId);
        formData.append('tipo', tipo);
        formData.append('arquivo', arquivo);

        if (descricao) {
            formData.append('descricao', descricao);
        }

        return api.post(RECURSO_DOCUMENTOS, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}

const historicoClinicoService = new HistoricoClinicoService();

export default historicoClinicoService;
